var map = {
	"./flags/be.svg": 34,
	"./flags/cn.svg": 35,
	"./flags/de.svg": 36,
	"./flags/es.svg": 37,
	"./flags/fr.svg": 38,
	"./flags/gb.svg": 39,
	"./flags/it.svg": 40,
	"./flags/jp.svg": 41,
	"./flags/us.svg": 42,
	"./icons/back.svg": 43,
	"./icons/close.svg": 44,
	"./icons/error.svg": 45,
	"./icons/external.svg": 46,
	"./icons/facebook.svg": 47,
	"./icons/info.svg": 48,
	"./icons/instagram.svg": 49,
	"./icons/linkedin.svg": 50,
	"./icons/marker.svg": 51,
	"./icons/mute.svg": 52,
	"./icons/pinterest.svg": 53,
	"./icons/scroll-top.svg": 54,
	"./icons/slider-arrow.svg": 55,
	"./icons/success.svg": 56,
	"./icons/twitter.svg": 57,
	"./icons/weibo.svg": 58,
	"./icons/youtube.svg": 59,
	"./logo-disclaimer.png": 60,
	"./logo-icon.svg": 61,
	"./logo.png": 62,
	"./logo.svg": 63,
	"./wines-slider-bg.png": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;